import { create } from 'zustand';

type UseFolderNumberState = {
  folderNumber?: string;
  hasCrossingInfoBannerBeenSaved?: boolean;
};

export const useFolderNumberState = create<UseFolderNumberState>(() => ({}));
